(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-home-hero"] && !Shopify.designMode) return;
  try {
    
  class ZgHomeHero extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-zg-slide]')];
      this.copies = [...this.querySelectorAll('[data-zg-copy]')];
      this.tabs = [...this.querySelectorAll('[data-zg-tab]')];
      this.live = this.querySelector('[data-zg-live]');
      this.autoplay = Number(this.dataset.autoplay) || 6500;
      this.style.setProperty('--zg-autoplay', `${this.autoplay}ms`);
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewportMq = window.matchMedia('(max-width: 749px)');
      this.onViewportChange = () => this.syncMedia();
      this.timer = null;
      this.touchX = null;

      const prev = this.querySelector('[data-zg-prev]');
      const next = this.querySelector('[data-zg-next]');

      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.goTo(Number(tab.dataset.index)));
      }

      this.addEventListener('pointerenter', () => this.classList.add('is-paused'));
      this.addEventListener('pointerleave', () => this.classList.remove('is-paused'));
      this.addEventListener('touchstart', (event) => {
        this.touchX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        const start = this.touchX;
        const end = event.changedTouches[0]?.clientX;
        this.touchX = null;
        if (start == null || end == null) return;
        const delta = end - start;
        if (Math.abs(delta) < 48) return;
        this.goTo(delta < 0 ? this.index + 1 : this.index - 1);
      });

      this.viewportMq.addEventListener('change', this.onViewportChange);
      this.prepareVideos();
      this.goTo(0, true);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.viewportMq?.removeEventListener('change', this.onViewportChange);
    }

    prepareVideos() {
      for (const video of this.querySelectorAll('video')) {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.loop = true;
        video.controls = false;
      }
    }

    syncMedia() {
      const mobile = this.viewportMq.matches;

      for (const [i, slide] of this.slides.entries()) {
        const active = i === this.index;

        for (const video of slide.querySelectorAll('video')) {
          const layer = video.closest('[data-zg-media]');
          const layerOk = layer?.dataset.zgMedia === (mobile ? 'movil' : 'pc');

          if (active && layerOk && !this.reduce) {
            const play = video.play();
            if (play) play.catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      }
    }

    goTo(next, silent) {
      if (!this.slides.length) return;
      const len = this.slides.length;
      this.index = ((next % len) + len) % len;

      for (const [i, slide] of this.slides.entries()) {
        const on = i === this.index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      }

      for (const [i, copy] of this.copies.entries()) {
        const on = i === this.index;
        copy.classList.toggle('is-active', on);
        copy.hidden = !on;
      }

      for (const [i, tab] of this.tabs.entries()) {
        const on = i === this.index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        const bar = tab.querySelector('[data-zg-bar]');
        if (bar && on) {
          const clone = bar.cloneNode(true);
          bar.replaceWith(clone);
        }
      }

      this.syncMedia();

      const title = this.copies[this.index]?.querySelector('.zg-home-hero__title');
      if (this.live && title && !silent) {
        this.live.textContent = `Slide ${this.index + 1} de ${len}: ${title.textContent}`;
      }

      this.start();
    }

    start() {
      this.stop();
      if (this.reduce || this.slides.length < 2) return;
      this.timer = window.setTimeout(() => this.goTo(this.index + 1), this.autoplay);
    }

    stop() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('zg-home-hero')) {
    customElements.define('zg-home-hero', ZgHomeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-home-industry"] && !Shopify.designMode) return;
  try {
    
  class ZgHomeFade extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-zg-fade-slide]')];
      this.copies = [...this.querySelectorAll('[data-zg-fade-copy]')];
      const prev = this.querySelector('[data-zg-fade-prev]');
      const next = this.querySelector('[data-zg-fade-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
    }

    go(next) {
      if (!this.slides.length) return;
      const len = this.slides.length;
      this.index = ((next % len) + len) % len;
      this.slides.forEach((slide, i) => {
        const on = i === this.index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      this.copies.forEach((copy, i) => {
        const on = i === this.index;
        copy.classList.toggle('is-active', on);
        copy.hidden = !on;
      });
    }
  }

  if (!customElements.get('zg-home-fade')) {
    customElements.define('zg-home-fade', ZgHomeFade);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-hub"]) return;
  try {
    
  class ZgHub extends HTMLElement {
    connectedCallback() {
      this.currency = this.dataset.currency || 'COP';
      this.locale = this.dataset.locale || 'es-CO';
      this.productType = this.dataset.productType || '';
      this.collection = this.dataset.collection || 'silla-gamer';
      this.grid = this.querySelector('[data-zg-colors]');
      this.status = this.querySelector('[data-zg-colors-status]');
      this.priceFrom = this.querySelector('[data-zg-price-from]');
      this.syncMedia();
      this.loadColors();
    }

    syncMedia() {
      const layers = this.querySelectorAll('[data-zg-hub-media]');
      const desktop = window.matchMedia('(min-width: 750px)').matches;

      for (const layer of layers) {
        const video = layer.querySelector('video');
        const isPc = layer.dataset.zgHubMedia === 'pc';
        const visible = desktop ? isPc : !isPc;

        if (!video) continue;

        if (visible) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    }

    async loadColors() {
      if (!this.grid || !this.productType) return;

      const products = await this.fetchCollection(this.collection);
      const matches = [];

      for (const product of products) {
        if (product.product_type !== this.productType) continue;
        if (!this.availablePrice(product)) continue;
        matches.push(product);
      }

      this.renderColors(matches);
      this.updatePriceFrom(matches);
    }

    async fetchCollection(handle) {
      const all = [];

      for (let page = 1; page <= 8; page += 1) {
        try {
          const response = await fetch(`/collections/${handle}/products.json?limit=50&page=${page}`);
          if (!response.ok) break;
          const data = await response.json();
          const batch = Array.isArray(data.products) ? data.products : [];
          all.push(...batch);
          if (batch.length < 50) break;
        } catch (error) {
          console.error('ZG hub: no se pudo leer', handle, error);
          break;
        }
      }

      return all;
    }

    availablePrice(product) {
      const variants = (product.variants || []).filter((variant) => variant.available);
      if (!variants.length) return null;

      let min = Number.POSITIVE_INFINITY;

      for (const variant of variants) {
        const price = Number(variant.price) || 0;
        if (price > 0 && price < min) min = price;
      }

      return Number.isFinite(min) ? min : null;
    }

    formatMoney(amount) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 0,
      }).format(Number(amount) || 0);
    }

    escape(value) {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;');
    }

    colorLabel(product) {
      const title = product.title || '';
      const match = title.match(/\b(black|white|pink|grey|gray|red|blue|rosa|negro|blanco|gris|rojo)\b/i);
      if (match) return match[1];
      return title;
    }

    updatePriceFrom(products) {
      if (!this.priceFrom) return;

      let min = Number.POSITIVE_INFINITY;

      for (const product of products) {
        const price = this.availablePrice(product);
        if (price != null && price < min) min = price;
      }

      if (!Number.isFinite(min)) return;

      this.priceFrom.hidden = false;
      this.priceFrom.textContent = `Desde ${this.formatMoney(min)}`;
    }

    renderColors(products) {
      if (!this.grid) return;

      if (!products.length) {
        this.grid.innerHTML = '';
        if (this.status) this.status.textContent = 'No hay colores en stock para este modelo.';
        return;
      }

      const parts = [];

      for (const product of products) {
        const price = this.availablePrice(product);
        const image = product.featured_image || product.images?.[0]?.src || '';
        const href = `/products/${product.handle}`;
        const label = this.escape(this.colorLabel(product));
        const alt = this.escape(product.title || label);

        parts.push(`
          <li>
            <a class="zg-hub-colors__card" href="${href}">
              <div class="zg-hub-colors__media">
                ${
                  image
                    ? `<img class="zg-hub-colors__img" src="${this.escape(image)}" alt="${alt}" width="800" height="800" loading="lazy">`
                    : '<div class="zg-hub-colors__ph" aria-hidden="true"></div>'
                }
              </div>
              <h3 class="zg-hub-colors__title">${label}</h3>
              <p class="zg-hub-colors__price">${this.formatMoney(price)}</p>
            </a>
          </li>
        `);
      }

      this.grid.innerHTML = parts.join('');

      if (this.status) {
        this.status.textContent = `${products.length} colores disponibles.`;
      }
    }
  }

  if (!customElements.get('zg-hub')) {
    customElements.define('zg-hub', ZgHub);
  }

  } catch(e) { console.error(e); }
})();
})();
